import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";

import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import ScanCompDialog from "../components/ScanCompDialog";
import ScanErrorDialog from "../components/ScanErrorDialog";

import QrReader from "react-qr-scanner";
import {
  Button,
  Typography,
  Alert,
  IconButton,
  Box,
  Collapse,
  CircularProgress,
  Stack,
} from "@mui/material";
import { checkGuestAttend } from "../Service";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const AutoReception = () => {
  const theme = useTheme();
  //   const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [openAlert, setOpenAlert] = useState(false);

  const [data, setData] = useState("No result");
  const [isScanning, setIsScanning] = useState(true);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [guestInfo, setGuestInfo] = useState(null);
  const [scanDialogOpen, setScanDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleScan = async (result) => {
    if (result) {
      setLoading(true);
      setIsScanning(false);
      const scannedData = typeof result === "object" ? result.text : result;
      setData(scannedData);

      if (!scannedData.startsWith("MN-")) {
        setErrorMessage("無効なQRコードです。");
        setErrorDialogOpen(true);
        // setIsScanning(false);
        return;
      }

      const guestId = scannedData.substring(3);
      try {
        const guestData = await checkGuestAttend(guestId);
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await sleep(2000);
        setGuestInfo(guestData);
        setIsScanning(false);
        setLoading(false);
        setScanDialogOpen(true);
      } catch (error) {
        console.log(error);
        setErrorMessage(error.message);
        setLoading(false);
        setErrorDialogOpen(true);
      }
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
    setIsScanning(true);
  };

  const handleCloseDialog = () => {
    setScanDialogOpen(false);
    setIsScanning(true);
  };

  //   const getSideLabel = (side) => {
  //     switch (side) {
  //       case "groom":
  //         return "新郎";
  //       case "bride":
  //         return "新婦";
  //       default:
  //         return "未定義";
  //     }
  //   };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {loading ? (
        <Box
          sx={{
            position: "fixed", // 画面に固定
            top: "50%", // 垂直方向の中央
            left: "50%", // 水平方向の中央
            transform: "translate(-50%, -50%)", // 自身の中心を基準に中央に配置
            zIndex: 1100, // 他の要素の上に表示（必要に応じて調整）
          }}
        >
          <CircularProgress size={60} color="primary" />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              position: "fixed", // 固定位置にする
              right: 0, // 画面右端に配置
              bottom: 0, // 画面下端に配置
              zIndex: 3000, // AppBarよりも上に表示
              width: "auto", // 幅を自動にする
              maxWidth: "400px", // 幅を制限（必要に応じて調整）
              padding: 2, // 少し余白を加える
            }}
          >
            <Collapse in={openAlert}>
              <Alert
                variant="filled"
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenAlert(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {errorMessage}
              </Alert>
            </Collapse>
          </Box>

          <Box
            sx={{
              p: 3,
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Grid container spacing={2} sx={{ width: "100%", height: "100%" }}>
              <Grid
                item
                size={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Stack
                  spacing={3}
                  sx={{ alignItems: "center", justifyContent: "center" }}
                >
                  <Typography variant="h5">
                    QRコードを読み込ませてください
                  </Typography>

                  <Stack
                    spacing={1}
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Typography variant="body">
                      ※読み込めない場合はこちらをタップしてください
                    </Typography>

                    <Button
                      variant="contained"
                      sx={{ width: "100%" }}
                      onClick={() => window.location.reload()}
                    >
                      リロード
                    </Button>
                  </Stack>
                </Stack>
              </Grid>

              <Grid
                item
                size={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isScanning ? (
                  <Box>
                    {/* <Box className="spacer-md"></Box> */}
                    {/* <QrScanner
                                    delay={300}
                                    onError={handleError}
                                    onScan={handleScan}
                                    style={{ width: '100%' }}
                                    facingMode="front"
                                /> */}
                    <QrReader
                      delay={300}
                      onError={handleError}
                      onScan={handleScan}
                      style={{ width: "100%" }}
                      facingMode="rear"
                    />

                    {/* <CustomQrScanner
                                    delay={300}
                                    onError={handleError}
                                    onScan={handleScan}
                                    style={{ width: '100%' }}
                                    facingMode="environment"
                                /> */}
                  </Box>
                ) : (
                  <Box sx={{ width: "100%", height: "100%" }}>
                    {/* 空の状態でもサイズを確保 */}
                    <Typography variant="h5"></Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>

          {/* エラーダイアログ */}
          {/* <Dialog open={errorDialogOpen} onClose={handleCloseErrorDialog}>
                    <DialogTitle>エラー</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">
                            {errorMessage}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseErrorDialog} color="primary">閉じる</Button>
                    </DialogActions>
                </Dialog> */}

          <ScanCompDialog
            open={scanDialogOpen}
            onClose={handleCloseDialog}
            guestInfo={guestInfo}
          />

          <ScanErrorDialog
            open={errorDialogOpen}
            onClose={handleCloseErrorDialog}
            message={errorMessage}
          />
        </>
      )}
    </ThemeProvider>
  );
};

export default AutoReception;
